import { render } from "./OpeningBalance.vue?vue&type=template&id=5b76aef4&scoped=true"
import script from "./OpeningBalance.vue?vue&type=script&lang=js"
export * from "./OpeningBalance.vue?vue&type=script&lang=js"

import "./OpeningBalance.vue?vue&type=style&index=0&id=5b76aef4&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b76aef4"]])

export default __exports__